import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { t, TranslationKey, TranslationService } from '@lib/translation';

import { IFsLprProviderInterface } from '../../api';
import { AlprExportDialogData, AlprCsvExportConfiguration } from '../../interfaces';
import { LPRProviderNameMapperPipe } from '../../shared/pipes';

@Component({
  selector: 'fs-csv-export-dialog',
  templateUrl: './csv-export-dialog.component.html',
  styleUrls: ['./csv-export-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [LPRProviderNameMapperPipe],
})
export class CsvExportDialogComponent {
  constructor(
    private readonly _matDialogRef: MatDialogRef<CsvExportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AlprExportDialogData,
    private readonly translationService: TranslationService,
    private readonly lprProviderNameMapperPipe: LPRProviderNameMapperPipe,
  ) {}

  public cancel(): void {
    this._matDialogRef.close();
  }

  public exportAll(): void {
    this._matDialogRef.close({
      exportAll: true
    } as AlprCsvExportConfiguration);
  }

  public getProviderDisplayName(provider: IFsLprProviderInterface): string {
    // For SDM providers with nameEnum, use translation
    if (provider.nameEnum) {
      const translationKey = this.lprProviderNameMapperPipe.transform(provider.nameEnum);
      return this.translationService.translate(translationKey as unknown as TranslationKey);
    }
    
    // Fallback for non-SDM providers
    return provider.name === 'Fusus' ? 'Other' : provider.name;
  }

  public formatResultCount(count: number): string {
    return count >= 9999 ? '9,999+' : count.toLocaleString();
  }

  public getFilteredProviders(): IFsLprProviderInterface[] {
    // Only show providers that have results
    return this.data.providers.filter(provider => provider.total > 0);
  }
}
